import { render } from "./Projetos.vue?vue&type=template&id=737e3120&scoped=true&ts=true"
import script from "./Projetos.vue?vue&type=script&lang=ts"
export * from "./Projetos.vue?vue&type=script&lang=ts"

import "./Projetos.vue?vue&type=style&index=0&id=737e3120&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-737e3120"]])

export default __exports__